import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { SelectionModel } from "@angular/cdk/collections";
import { ModTable, TableRow } from 'core-lib';
import { MatTable, MatTableModule } from '@angular/material/table';
import { Sort, MatSortModule } from '@angular/material/sort';
import { intersection } from "es-toolkit";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'ls-table',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ls-table.component.html',
    styleUrls: ['./ls-table.component.scss'],
    standalone: true,
    imports: [MatTableModule, MatSortModule, NgIf, MatButtonModule, MatIconModule, MatCheckboxModule, NgFor, NgClass, MatTooltipModule]
})
export class LsTableComponent implements OnInit, OnChanges, AfterViewInit {

    @ViewChild('myTable') table: MatTable<TableRow>;

    @Input() data: ModTable;
    @Input() selected: ModTable;
    @Input() enabled: boolean = false;
    @Input() disableDownload: boolean = false;
    @Input() helper: (id: string) => void;

    @Output() change = new EventEmitter<{ selected: boolean, value: ModTable }>();
    @Output() showHelp = new EventEmitter<{ id: string }>();

    checked: boolean = false;
    displayedCols: string[] = [];
    headerCols: string[] = [];
    selection: SelectionModel<TableRow>;// = new SelectionModel<TableRow>(true, []);

    _data: TableRow[];
    tableId: string;

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.data.body.length;
        return numSelected == numRows;
    }

    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.data.body.forEach(row => this.selection.select(row));
        this.change.emit({
            selected: !!this.selection.selected.length, value: {
                ...this.data,
                body: this._data
            }
        });
    }

    toggleRow(row: TableRow) {
        this.selection.toggle(row);
        this.change.emit({
            selected: !!this.selection.selected.length,
            value: { ...this.data, body: intersection(this._data, this.selection.selected) }
        });
    }

    sortData(sort: Sort) {
        this.selection.clear();
        // this.change.emit({ selected: false, value: this.data });
        const data = this.data.body.slice();
        if (!sort.active || sort.direction === '') {
            this._data = data;
            return;
        }
        this._data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            return compare(a[sort.active], b[sort.active], isAsc);
            // switch (sort.active) {
            //     case 'name': return compare(a.name, b.name, isAsc);
            //     case 'calories': return compare(a.calories, b.calories, isAsc);
            //     case 'fat': return compare(a.fat, b.fat, isAsc);
            //     case 'carbs': return compare(a.carbs, b.carbs, isAsc);
            //     case 'protein': return compare(a.protein, b.protein, isAsc);
            //     default: return 0;
            // }
        });
    }

    ngOnInit() {
        this.displayedCols = this.enabled ? ['select', ...(this.data?.displayedCols || [])] : this.data?.displayedCols || [];
        this.headerCols = this.enabled ? ['select', ...(this.data?.header_row.filter(col => col.value).map(col => col.id) || [])] : this.data?.header_row.filter(col => col.value).map(col => col.id) || [];
        const selected: TableRow[] = this.selected ? this.selected.body : [];
        this.selection = new SelectionModel(true, selected);
        // console.log(this.headerCols);
        setTimeout(() => this.table.renderRows(), 500);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.enabled && !changes.enabled.isFirstChange()) {
            if (changes.enabled.currentValue) {
                this.displayedCols = ['select', ...this.data.displayedCols];
                if (!this.selected) {
                    this.table.renderRows();
                }
            } else {
                this.selection.clear();
            }
        }
        if (changes.data && changes.data.currentValue) {
            if (changes.data.currentValue.id === 'rst_app_usage_0') {
                console.log(changes.data.currentValue);
                setTimeout(() => {
                    console.log(this.data.header_row);
                    // console.log(this.headerCols);
                }, 2000)

            }
            
            this._data = this.data.body.slice();
            this.displayedCols = this.data.displayedCols;
            this.headerCols = this.enabled ? ['select', ...(this.data?.header_row.filter(col => col.value).map(col => col.id) || [])] : this.data?.header_row.filter(col => col.value).map(col => col.id) || [];
            if (!changes.data.isFirstChange()) {
                setTimeout(() => {
                    this.table.renderRows();
                }, 500);
            }
            // setTimeout(() => {
            //     this.table.renderRows();
            // }, 100);
            // this.tableId = this.data.id + Math.floor(Math.random() * 100 + 1) ?? 'tableId_' + Math.floor(Math.random() * 100 + 1); 
            this.tableId = this.data.id + Math.floor(Math.random() * 100 + 1);// ?? 'tableId_' + Math.floor(Math.random() * 100 + 1); 
        }
        if (changes.selected && !changes.selected.isFirstChange()) {
            if (changes.selected.currentValue) {
                this.selection.select(...this.selected.body);
            }
        }
    }

    ngAfterViewInit() {
        // console.log('HI', this.table);
        setTimeout(() => {
            this.table.renderRows();
        }, 500);
    }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
